import React from 'react';
import './style.css';
import Logo from '../../assets/images/Desapedia-01.png';

const LoadingOverlay = () => {
  return (
    <>
      <div
        className='loading-overlay'
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          padding: 0,
          margin: 0,
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <img src={Logo} alt="Loading..." className="loading-logo-pulse" style={{ zIndex: 999 }} />
      </div>
    </>
  );
};

export default LoadingOverlay;
